import { UseFormReturn, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';

import {
    GATEWAY_DISPLAY_MODEL_TRANSLATIONS_MAP,
    IDLE_STATE_TRANSLATIONS_MAP,
    ORIENTATION_TRANSLATIONS_MAP,
} from 'src/features/systems/utils/constants';

import InputFormField from 'src/registry/components/forms/InputFormField';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { systemsMessages } from 'src/features/systems/utils/messages';
import { SystemComponentFormSchemaValues } from 'src/features/systems/utils/formSchema';
import { GATEWAY_DISPLAY_MODEL, IDLE_STATE, ORIENTATION } from 'src/features/systems/utils/types';

type GatewayDisplayFormFieldsProps = {
    form: UseFormReturn<SystemComponentFormSchemaValues>;
};

const GatewayDisplayFormFields = ({ form }: GatewayDisplayFormFieldsProps) => {
    const { formatMessage } = useIntl();
    const displayModel = useWatch({ control: form.control, name: 'data.display_model' });

    return (
        <>
            <SelectFormField<SystemComponentFormSchemaValues>
                options={Object.values(GATEWAY_DISPLAY_MODEL)}
                form={form}
                name="data.display_model"
                label={formatMessage(systemsMessages.displayModel)}
                optionTranslationMap={GATEWAY_DISPLAY_MODEL_TRANSLATIONS_MAP}
            />
            {displayModel === GATEWAY_DISPLAY_MODEL.SP && (
                <>
                    <InputFormField<SystemComponentFormSchemaValues>
                        form={form}
                        name="data.display_server_ip"
                        label={formatMessage(systemsMessages.displayServerIP)}
                    />
                    <InputFormField<SystemComponentFormSchemaValues>
                        form={form}
                        name="data.display_server_api_key"
                        label={formatMessage(systemsMessages.displayServerApiKey)}
                    />
                    <SelectFormField<SystemComponentFormSchemaValues>
                        options={Object.values(IDLE_STATE)}
                        form={form}
                        name="data.idle_state"
                        label={formatMessage(systemsMessages.idleState)}
                        optionTranslationMap={IDLE_STATE_TRANSLATIONS_MAP}
                    />
                    <SelectFormField<SystemComponentFormSchemaValues>
                        options={Object.values(ORIENTATION)}
                        form={form}
                        name="data.orientation"
                        label={formatMessage(systemsMessages.orientation)}
                        optionTranslationMap={ORIENTATION_TRANSLATIONS_MAP}
                    />
                </>
            )}
            {displayModel === GATEWAY_DISPLAY_MODEL.HUIDU && (
                <>
                    <InputFormField<SystemComponentFormSchemaValues>
                        form={form}
                        name="data.display_server_ip"
                        label={formatMessage(systemsMessages.displayServerIP)}
                    />
                    <InputFormField<SystemComponentFormSchemaValues>
                        form={form}
                        name="data.screen_width"
                        type="number"
                        label={formatMessage(systemsMessages.screenWidth)}
                    />
                    <InputFormField<SystemComponentFormSchemaValues>
                        form={form}
                        name="data.screen_height"
                        type="number"
                        label={formatMessage(systemsMessages.screenHeight)}
                    />
                </>
            )}
            {displayModel === GATEWAY_DISPLAY_MODEL.NED200 && (
                <InputFormField<SystemComponentFormSchemaValues>
                    form={form}
                    name="data.display_server_ip"
                    label={formatMessage(systemsMessages.displayServerIP)}
                />
            )}
        </>
    );
};

export default GatewayDisplayFormFields;
